import { isValid, format, parseISO } from 'date-fns'

export default {
  methods: {
    tagName (tag) {
      const trans = this.$t(`tag_${tag}`)
      return trans !== `tag_${tag}` ? trans : tag
    },
    dateformat (dateRaw) {
      const date = parseISO(dateRaw)
      return isValid(date) ? format(date, this.$t('blog_dateformat_new')) : ''
    }
  }
}
